import { numerico } from './mascarasHelper';

const rem = number =>
    number.toString().match(/^\d+$/) || number.toString().indexOf('px') !== -1
        ? `${parseFloat(number.toString()) / 16}rem`
        : number;

const subtract1Px = number =>
    `${parseFloat(number.toString().replace('px', '')) - 1}px`;

const setSizes = sizes => {
    switch (typeof sizes) {
        case 'number':
            return `${sizes}px`;
        case 'object':
            if (sizes instanceof Array) {
                return sizes.reduce((acc, current) => {
                    if (typeof current === 'number') {
                        return `${acc} ${current}px`;
                    }
                    return acc + current;
                }, '');
            }

            return '0 auto';
        case 'string':
            return sizes;
        default:
            throw Error(
                'Invalid parameter type. setSizes accepts string, number or an array of numbers/strings'
            );
    }
};

const __addModule = __req => {
    const mappedComp = {};
    __req.keys().forEach(filename => {
        const objects = __req(filename);
        Object.getOwnPropertyNames(objects)
            .filter(name => {
                if (name === '__esModule' || name === 'default') return false;
                return true;
            })
            .forEach(name => {
                mappedComp[name] = objects[name];
            });
    });
    return mappedComp;
};

const gradient = (direction, colors, colorModifier) =>
    Object.keys(colors).reduce(
        (acc, current) =>
            `${acc}, ${
                colorModifier ? colorModifier(colors[current]) : colors[current]
            } ${current}%`,
        `${direction}`
    );

const soma = (items, prop) => {
    if (items == null) {
        return 0;
    }
    return items.reduce((a, b) => (b[prop] == null ? a : a + b[prop]), 0);
};

const maximoDeFaturas = (terminais, length) => {
    const max = length || 3;
    let nExibe = true;
    if (terminais.length <= max) {
        terminais.filter(e => {
            if (e.faturas.length > max) {
                nExibe = false;
                return false;
            }
            return true;
        });
    } else {
        nExibe = false;
    }
    return nExibe;
};

const deParaVignette = (idFuncionalidade, terminal, categoria) => {
    const parametros = [idFuncionalidade];
    if (terminal) {
        const numeroTerminal = numerico(terminal);
        parametros.push(`numTerminal=${numeroTerminal}`);
    }

    if (categoria) parametros.push(`categoriaPlano=${categoria}`);

    return encodeURI(`${process.env.API_VIGNETTE_URL}${parametros.join('&')}`);
};

const getColor = props => {
    // let cor1 = props.color ? props.color : "#000";
    const cor = props.themeColor ? props.themeColor : '#000000';
    return cor;
};

const resolveColor = (color, theme) =>
    color.indexOf('#') !== -1 || color === 'currentColor'
        ? color
        : theme.colors[color];

const applyStyle = ({ style }) => style;

export {
    rem,
    subtract1Px,
    setSizes,
    gradient,
    __addModule,
    getColor,
    soma,
    maximoDeFaturas,
    deParaVignette,
    resolveColor,
    applyStyle
};
